<div class="sender-partial-container">
  <div>
    <h1>Отправитель</h1>

    <el-form-item label="Город отправки" prop="sender.cityFrom">
      <el-select v-model="dataForm.sender.cityFrom" placeholder="Выберите город" filterable v-cancel-read-only autocomplete="do-not-autofill" @change="hanlerCityFrom">
        <el-option v-for="(city, index) in citiesArr" :key="index" :label="city.name" :value="city.name" :disabled="disableIdenticalCity(city.name)" />
      </el-select>
    </el-form-item>

    <el-form-item prop="sender.senderType">
      <el-switch v-model="dataForm.sender.senderType" inactive-text="Физ.лицо" active-text="Юр.лицо" />
    </el-form-item>

    <el-form-item v-if="dataForm.sender.senderType" label="ИНН отправителя" prop="sender.innSender">
      <el-input v-model="dataForm.sender.innSender" type="text" autocomplete="on" v-mask="INN_MASK" @change="getNameOrganization('sender', dataForm.sender.innSender)" />
    </el-form-item>
    <el-form-item v-if="dataForm.sender.senderType" label="Наименование организации" prop="sender.name">
      <el-input type="text" autocomplete="on" v-model="dataForm.sender.name" />
    </el-form-item>

    <el-form-item class="align-items--flex-end_el-form-item__content">
      <el-col :span="11">
        <el-form-item label="Телефон отправителя" prop="sender.phoneSender" class="sender-partial-container__phone">
          <el-input
            v-model="dataForm.sender.phoneSender"
            v-mask="PHONE_MASK"
            type="tel"
            :formatter="(value) => `${value}`.replace(/\(89/g, '9')"
            :placeholder="PHONE_PLACEHOLDER"
            @change="checkPhone"
          />
        </el-form-item>
      </el-col>
      <el-col :span="2" />
      <el-col :span="11">
        <el-form-item label="Эл. почта" prop="sender.emailSender" :required="dataForm.sender.senderType">
          <el-input type="email" autocomplete="email" v-model="dataForm.sender.emailSender" />
        </el-form-item>
      </el-col>
    </el-form-item>

    <el-form-item label="ФИО отправителя" v-if="!dataForm.sender.senderType" class="margin-bottom--30-p">
      <el-col :span="7">
        <el-form-item prop="sender.surnameSender">
          <el-input
            placeholder="Фамилия"
            type="text"
            autocomplete="family-name"
            v-model="dataForm.sender.surnameSender"
            @keyup="dataForm.sender.surnameSender = limitInput(dataForm.sender.surnameSender)"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1" class="multiplication"></el-col>
      <el-col :span="7">
        <el-form-item prop="sender.firstNameSender">
          <el-input
            placeholder="Имя"
            type="text"
            autocomplete="given-name"
            v-model="dataForm.sender.firstNameSender"
            @keyup="dataForm.sender.firstNameSender = limitInput(dataForm.sender.firstNameSender)"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1" class="multiplication"></el-col>
      <el-col :span="7">
        <el-form-item prop="sender.secondNameSender">
          <el-input
            placeholder="Отчество"
            type="text"
            autocomplete="additional-name"
            v-model="dataForm.sender.secondNameSender"
            @keyup="dataForm.sender.secondNameSender = limitInput(dataForm.sender.secondNameSender)"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-form-item>
  </div>

  <div class="container_button">
    <el-form-item>
      <!-- <router-link to="/calculator" class="button-link">
        <el-button 
          class="button_shadow"
          type="primary"
        > 
          Калькулятор
        </el-button>
      </router-link> -->
    </el-form-item>
    <el-form-item>
      <!-- <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next')"
        >
        Далее
      </el-button> -->
    </el-form-item>
  </div>
</div>
